import React from 'react';
import RolePrivateRoute from 'src/components/PrivateRotes/RolePrivateRoute';
import InterestBalanceListView from './components/InterestBalanceListView';
import { fiscalInterestBalanceConfig } from './config';

const FiscalInterestBalanceListPage = () => (
  <InterestBalanceListView config={fiscalInterestBalanceConfig} />
);

const FiscalInterestBalanceView = () => {
  return (
    <>
      <RolePrivateRoute
        component={FiscalInterestBalanceListPage}
      />
    </>
  );
};


export default FiscalInterestBalanceView;
